import type {DataFooterSelection, JsonResponse} from "~/types/types";
import {api_header} from "~/types/api_header";

export class ApplyAction {

    apply = async (action: IAction): Promise<JsonResponse> => {
        const cfg = useRuntimeConfig()

        return await $fetch<JsonResponse>(`/api/apply-action/`, {
            baseURL: String(useNuxtApp().$apiUrl()),
            headers: api_header(),
            method: 'POST',
            body: action
        })
    }
}

export interface IAction extends DataFooterSelection{
    target: string,
    filter: any,
}
